import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const userModule = {
  namespaced: true,
  state: {
    userData: null,
    config: null,
    support: null
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      state.userData = userData;
      state.config = userData.config || null;
      state.support = (userData.config && userData.config.support) || null;
    },
    RESET_USER_DATA(state) {
      state.userData = null;
      state.config = null;
      state.support = null;
    }
  },
  actions: {
    setUserData({ commit }, userData) {
      commit('SET_USER_DATA', userData);
      if (userData) {
        localStorage.setItem('user', JSON.stringify(userData));
      }
    },
    resetUserData({ commit }) {
      commit('RESET_USER_DATA');
      localStorage.removeItem('user');
    }
  },
  getters: {
    support: state => state.support,
    config: state => state.config,
    userData: state => state.userData
  }
};

export default new Vuex.Store({
  modules: {
    user: userModule
  },
  state: {
    loading: 0
  },
  mutations: {
    changeLoading(state, payload) {
      state.loading = payload;
    }
  },
  actions: {
  }
})
